var skanGym = skanGym || {};

$(window).load(function(){
    skanGym.embed.youtube($('iframe[src*="youtube.com"]'));
});

skanGym.embed = new function (selectors) {
    this.youtube = function(selectors) {
        selectors.each(function() {
            var $this = $(this),
            	src = $this.attr('src');

            if(src.indexOf('wmode') == -1) {
            	var wmode = 'wmode=transparent&rel=0&showinfo=0&controls=2&autohide=1',
            		stringConcatinator = src.indexOf('?') == -1 ? '?' : '&';
            		attrValue = src + stringConcatinator + wmode;

        		$this.attr('src', attrValue);
            }
        });
    }
};